import React, { Component } from "react";
import { NumberInput } from "../components/NumberInput.tsx";
import { ErrorBox } from "../components/ErrorBox.tsx";
import {
  ICalculationResult,
  ILenderProduct,
  ISwitcherCalculationRequest,
  ProductCategory,
} from "../helpers/Models.tsx";
import axios from "axios";
import { NumberAsCurrency } from "../components/NumberAsCurrency.tsx";
import { GetStartedButton } from "../components/GetStartedButton.tsx";
import { TermSelect } from "../components/TermSelect.tsx";
import { BerSelect } from "../components/BerSelect.tsx";
import { LenderRow } from "../components/LenderRow.tsx";

interface IProps {
  gtmEvent(): void;
  nextStep(response: string, loadJourney: boolean): void;
  updateLead(props: any): void;
  homeValue?: number;
  existingMortgage?: number;
  remainingTerm?: number;
  repayments?: number;
  interestRate?: number;
  subtitle?: any;
}

interface IState {
  hasError: boolean;
  errors?: string[];
  homeValue: number | null;
  existingMortgage: number | null;
  remainingTerm: number | null;
  repayments?: number;
  interestRate?: number;
  exploreOptions: boolean;
  showSavings: boolean;
  calculationResult?: ICalculationResult;
  calculatingResults: boolean;
  ber: string | null;
}

export class SwitchingCalculator extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      calculatingResults: false,
      hasError: false,
      homeValue: this.props.homeValue ?? null,
      existingMortgage: this.props.existingMortgage ?? null,
      ber: null,
      exploreOptions: false,
      showSavings: false,
      remainingTerm: this.props.remainingTerm ?? 25,
    };
    this.calculateRepayments = this.calculateRepayments.bind(this);
    this.calculateRepaymentsDelayed =
      this.calculateRepaymentsDelayed.bind(this);
  }

  componentDidMount(): void {
    this.props.gtmEvent();
    if (!this.props.remainingTerm) this.props.updateLead({ remainingTerm: 25 });
  }

  nextStep() {
    if (!this.state.homeValue || !this.state.existingMortgage) {
      var errors: string[] = [];
      if (!this.state.homeValue) {
        errors.push("Home Value is required");
      }
      if (!this.state.existingMortgage) {
        errors.push("Mortgage Amount is required");
      }
      this.setState({ errors: errors, hasError: true });
      return;
    }
    this.props.nextStep("Switching Calculator", true);
  }

  calculateRepaymentsDelayed() {
    setTimeout(this.calculateRepayments, 500);
  }

  calculateRepayments() {
    var homeValue = this.state.homeValue;
    var existingMortgage = this.state.existingMortgage;
    var term = this.state.remainingTerm;
    var repayments = this.state.repayments;
    var interestRate = this.state.interestRate;
    var ber = this.state.ber;
    if (!homeValue || !existingMortgage || !term) {
      return;
    }

    if (existingMortgage / homeValue > 0.9) {
      var errors: string[] = [];
      errors.push(
        "Mortgage amount required cannot be greater than 90% of the property value"
      );
      //this.setState({errors: errors, hasError: true, showSavings: false, existingMortgage: Math.round(this.state.homeValue * 0.9)});
      this.setState({ errors: errors, hasError: true, showSavings: false });
      return;
    }

    this.setState({ calculatingResults: true, errors: [], hasError: false });

    var request: ISwitcherCalculationRequest = {
      purchasePrice: homeValue,
      mortgageAmount: existingMortgage,
      term: term,
      interestRate: interestRate,
      repayments: repayments,
      ber: ber,
    };
    axios
      .post("/Calculator/CalculateSwitcher", request)
      .then((response) => {
        this.setState({
          calculatingResults: false,
          calculationResult: response.data,
          showSavings: true,
        });
      })
      .catch((error) => {
        this.setState({ calculatingResults: false });
        //alert('submit error: ' + error.message);
      });
    // this.setState({checking: true});
  }

  fixedYearText(product: ILenderProduct): any {
    var rateText = "";
    if (!product) return "";
    if (product.fixedYears > 0) {
      rateText = `${product.fixedYears} year, ${product.type}`;
      if (rateText.endsWith("rate")) {
        rateText = rateText.replace("rate", "");
      }
    } else {
      rateText = product.type;
    }
    return rateText;
  }

  render() {
    var rates = [{}];
    if (this.state.calculationResult) {
      this.state.calculationResult.products.map(
        (p: ILenderProduct, i: number) => {
          return rates.push(p);
        }
      );
    }
    return (
      <header className="App-header">
        <div className="wrapper">
          {
            <>
              <div className="row row-mobile">
                <div className="column2">
                  <NumberInput
                    id="homeValue"
                    key="homeValue"
                    label={
                      <>
                        Approximate <strong>Property Value</strong>
                      </>
                    }
                    value={this.state.homeValue}
                    classes={
                      this.state.hasError && !this.state.homeValue ? "e" : ""
                    }
                    onBlur={() => this.calculateRepayments()}
                    onChange={(e) => {
                      this.setState({ homeValue: e.target.value });
                      this.props.updateLead({
                        mortgageType: "switcher",
                        homeValue: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="column2">
                  <NumberInput
                    id="mortgagevalue"
                    key="mortgagevalue"
                    label={
                      <>
                        Outstanding <strong>Balance</strong>
                      </>
                    }
                    value={this.state.existingMortgage}
                    classes={
                      this.state.hasError && !this.state.existingMortgage
                        ? "e"
                        : ""
                    }
                    onBlur={() => this.calculateRepayments()}
                    onChange={(e) => {
                      this.setState({ existingMortgage: e.target.value });
                      this.props.updateLead({
                        mortgageType: "switcher",
                        existingMortgage: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="row row-mobile">
                <div className="column2">
                  <TermSelect
                    label={
                      <>
                        <strong>Remaining term</strong> on your mortgage
                      </>
                    }
                    selectedterm={this.state.remainingTerm}
                    onChange={(e) => {
                      this.setState({ remainingTerm: +e.target.value });
                      this.props.updateLead({
                        mortgageType: "switcher",
                        remainingTerm: +e.target.value,
                      });
                      this.calculateRepaymentsDelayed();
                    }}
                  />
                </div>
                <div className="column2">
                  <BerSelect
                    label={
                      <>
                        <strong>BER</strong> of your home
                      </>
                    }
                    onChange={(e) => {
                      this.setState({ ber: e.target.value });
                      this.props.updateLead({
                        mortgageType: "switcher",
                        ber: e.target.value,
                      });
                      this.calculateRepaymentsDelayed();
                    }}
                  />
                </div>
              </div>
            </>
          }

          {this.state.hasError && (
            <ErrorBox hideTitle={true} errors={this.state.errors!} />
          )}

          {!(this.state.showSavings && this.state.calculationResult) && (
            <div className="row mt-2">
              <LenderRow showDisclaimer={true} />
            </div>
          )}

          {this.state.showSavings && this.state.calculationResult && (
            <div className="box chartreuse mt-2">
              <div className="row">
                <h2 className="h2-mobile">
                  Lowest market rates available to you today based on your
                  mortgage amount and loan to value.
                </h2>
                <p>
                  {this.state.calculationResult &&
                    this.state.calculationResult.cashback > 0 && (
                      <>
                        Up to{" "}
                        <NumberAsCurrency
                          value={this.state.calculationResult.cashback}
                        />{" "}
                        cashback available on your mortgage level
                      </>
                    )}
                </p>
                <div className="row">
                  <div className="column">
                    {this.state.calculationResult && (
                      <GetStartedButton onClick={() => this.nextStep()} />
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="repayment-table">
                  {this.state.calculationResult?.products.map(
                    (item: ILenderProduct, index: number) => {
                      if (index === 0) {
                        return (
                          <>
                            <div className="firstrow">
                              <div
                                className="first cell"
                                style={{ display: "block" }}
                              >
                                {/* <p>&nbsp;</p> */}
                                <div className="row mt-0 mb-0">
                                  {item.lenderLogo ? (
                                    <img
                                      className=""
                                      style={{
                                        height: "50px",
                                        marginTop: -5,
                                      }}
                                      src={item.lenderLogo}
                                    ></img>
                                  ) : (
                                    <h1>{item.lenderName}</h1>
                                  )}
                                </div>

                                <h2 className="mt-0">
                                  {this.state.calculationResult && (
                                    <>{this.fixedYearText(item)}</>
                                  )}
                                </h2>
                                {item.cashbackAmount && (
                                  <p className="s impact">
                                    Cashback{" "}
                                    <NumberAsCurrency
                                      value={item.cashbackAmount}
                                    />
                                  </p>
                                )}
                                {item.minBerText &&
                                  item.minBerText !== "ZZ" && (
                                    <>
                                      <p className="s impact">
                                        Min BER {item.minBerText}
                                      </p>
                                    </>
                                  )}
                              </div>
                              <div
                                className="middle cell"
                                style={{ display: "block" }}
                              >
                                <p>Monthly repayment</p>
                                <h1>
                                  {this.state.calculationResult && (
                                    <NumberAsCurrency
                                      value={
                                        this.state.calculationResult.repayment
                                      }
                                    />
                                  )}
                                </h1>
                              </div>
                              <div
                                className="last cell"
                                style={{ display: "block" }}
                              >
                                <p>Rate</p>
                                <h1>
                                  {this.state.calculationResult &&
                                    item.rate + "%"}
                                </h1>
                              </div>
                            </div>
                          </>
                        );
                      }
                      if (
                        index ===
                        this.state.calculationResult!.products.length - 1
                      ) {
                        return (
                          <>
                            <div className="lastrow">
                              <div className="first cell">
                                <div className="mt-0 mb-0">
                                  {item.lenderLogo ? (
                                    <img
                                      className=""
                                      style={{
                                        height: "50px",
                                      }}
                                      src={item.lenderLogo}
                                    ></img>
                                  ) : (
                                    <h1>{item.lenderName}</h1>
                                  )}
                                  <div>
                                    <p>
                                      {this.state.calculationResult &&
                                        this.fixedYearText(item)}
                                    </p>
                                    {item.cashbackAmount && (
                                      <p className="s impact">
                                        Cashback{" "}
                                        <NumberAsCurrency
                                          value={item.cashbackAmount}
                                        />
                                      </p>
                                    )}
                                    {item.category ===
                                      ProductCategory.Green && (
                                      <>
                                        <p className="s impact">
                                          Min BER {item.minBerText}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="middle cell">
                                <p>
                                  <span className="l">
                                    {this.state.calculationResult && (
                                      <NumberAsCurrency
                                        value={item.repayment}
                                      />
                                    )}
                                  </span>
                                </p>
                              </div>
                              <div className="last cell">
                                <p>
                                  {this.state.calculationResult &&
                                    item.rate + "%"}
                                </p>
                              </div>
                            </div>
                          </>
                        );
                      }
                      return (
                        <>
                          <div className="middlerow">
                            <div className="d-flex flex-column first cell">
                              <div className="mt-0 mb-0">
                                {item.lenderLogo ? (
                                  <img
                                    className=""
                                    style={{
                                      height: "50px",
                                    }}
                                    src={item.lenderLogo}
                                  ></img>
                                ) : (
                                  <h1>{item.lenderName}</h1>
                                )}
                                <div>
                                  <p>
                                    {this.state.calculationResult &&
                                      this.fixedYearText(item)}
                                  </p>
                                  {item.cashbackAmount && (
                                    <p className="s impact">
                                      Cashback{" "}
                                      <NumberAsCurrency
                                        value={item.cashbackAmount}
                                      />
                                    </p>
                                  )}
                                  {item.category === ProductCategory.Green && (
                                    <>
                                      <p className="s impact">
                                        Min BER {item.minBerText}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="middle cell">
                              <p>
                                <span className="l">
                                  {this.state.calculationResult && (
                                    <NumberAsCurrency value={item.repayment} />
                                  )}
                                </span>
                              </p>
                            </div>
                            <div className="last cell">
                              <p>
                                {this.state.calculationResult &&
                                  item.rate + "%"}
                              </p>
                            </div>
                          </div>
                        </>
                      );
                    }
                  )}
                  {/* <div className='firstrow'>
                                    <div className='first cell' style={{display: 'block'}}>
                                        <p>&nbsp;</p>
                                        <h2 className='mt-1'>{this.state.calculationResult && this.state.calculationResult?.products.length > 0 && <>{this.fixedYearText(this.state.calculationResult?.products[0])}</>}</h2>
                                    </div>
                                    <div className='middle cell' style={{display: 'block'}}>
                                        <p>Monthly repayment</p>
                                        <h1>{this.state.calculationResult && <NumberAsCurrency value={this.state.calculationResult.repayment} />}</h1>
                                    </div>
                                    <div className='last cell' style={{display: 'block'}}>
                                        <p>Rate</p>
                                        <h1>{this.state.calculationResult && this.state.calculationResult?.products.length > 0 && this.state.calculationResult?.products[0].rate+"%"}</h1>
                                    </div>
                                </div>
                                <div className='middlerow'>
                                    <div className='first cell'><p>{(this.state.calculationResult && this.state.calculationResult.products.length > 1 && this.fixedYearText(this.state.calculationResult.products[1]))}</p></div>
                                    <div className='middle cell'><p><span className='l'>{(this.state.calculationResult && this.state.calculationResult.products.length > 1 && <NumberAsCurrency value={this.state.calculationResult.products[1].repayment} />)}</span></p></div>
                                    <div className='last cell'><p>{this.state.calculationResult && this.state.calculationResult.products.length > 1 && this.state.calculationResult?.products[1].rate+"%"}</p></div>
                                </div>
                                <div className='lastrow'>
                                    <div className='first cell'><p>{(this.state.calculationResult && this.state.calculationResult.products.length > 2 && this.fixedYearText(this.state.calculationResult.products[2]))}</p></div>
                                    <div className='middle cell'><p><span className='l'>{(this.state.calculationResult && this.state.calculationResult.products.length > 2 && <NumberAsCurrency value={this.state.calculationResult.products[2].repayment} />)}</span></p></div>
                                    <div className='last cell'><p>{this.state.calculationResult && this.state.calculationResult.products.length > 2 && this.state.calculationResult?.products[2].rate+"%"}</p></div>
                                </div> */}
                </div>
                <div className="column1">
                  <div className="repayment-tile travertine">
                    <div className="column2 justify-s">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 0 &&
                          this.state.calculationResult?.products[0].rate + "%"}
                      </p>
                    </div>
                    <div className="column2d justify-e">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 0 && (
                            <>
                              {this.fixedYearText(
                                this.state.calculationResult?.products[0]
                              )}
                            </>
                          )}
                      </p>
                    </div>
                    <h1>
                      {this.state.calculationResult && (
                        <NumberAsCurrency
                          value={this.state.calculationResult.repayment}
                        />
                      )}
                    </h1>
                  </div>
                </div>
                <div className="column1">
                  <div className="repayment-tile teal">
                    <div className="column2 justify-s">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 1 &&
                          this.state.calculationResult?.products[1].rate + "%"}
                      </p>
                    </div>
                    <div className="column2d justify-e">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 1 && (
                            <>
                              {this.fixedYearText(
                                this.state.calculationResult?.products[1]
                              )}
                            </>
                          )}
                      </p>
                    </div>
                    <h1>
                      {this.state.calculationResult && (
                        <NumberAsCurrency
                          value={
                            this.state.calculationResult.products[1].repayment
                          }
                        />
                      )}
                    </h1>
                  </div>
                </div>
                <div className="column1">
                  <div className="repayment-tile teal">
                    <div className="column2 justify-s">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 2 &&
                          this.state.calculationResult?.products[2].rate + "%"}
                      </p>
                    </div>
                    <div className="column2d justify-e">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 2 && (
                            <>
                              {this.fixedYearText(
                                this.state.calculationResult?.products[2]
                              )}
                            </>
                          )}
                      </p>
                    </div>
                    <h1>
                      {this.state.calculationResult && (
                        <NumberAsCurrency
                          value={
                            this.state.calculationResult.products[2].repayment
                          }
                        />
                      )}
                    </h1>
                  </div>
                </div>
              </div>
              <div className="row mb-0">
                <p className="s">
                  Disclaimer: Our calculators give indicative figures and are
                  based on 35 year term unless another is selected. They are in
                  no way intended to constitute an offer. Such calculations are
                  made on the presumption that the information supplied by you
                  is accurate and is subject to approval by the actual lender.
                  Rates include Green rate options which only apply if BER is B3
                  or above. This web page is for illustrative purposes only, so
                  as to give you, the borrower, an overview of the potential
                  cost of borrowing.
                </p>
              </div>
            </div>
          )}

          {this.state.exploreOptions &&
            this.state.calculationResult.products.map(
              (p: ILenderProduct, i: number) => {
                return (
                  <div key={p.name + "-" + i.toString()} className="panel mt-1">
                    <div className="row mb-0">
                      <div className="row mb-0">
                        <h2>
                          {`${p.fixedYears ? p.fixedYears + " Year" : ""} ${
                            p.type
                          } LTV`}
                          <br />
                          {Math.round(p.maxLTV)}% Mortgage
                        </h2>
                      </div>
                      <div className="row mt-0">
                        <p className="mt-0">
                          Applies to LTV {Math.round(p.minLTV)}-
                          {Math.round(p.maxLTV)}%
                        </p>
                      </div>
                    </div>
                    <div className="row mt-0">
                      <div className="column3">
                        <label htmlFor="fixedrate1">{p.type} rate</label>
                        <p id="fixedrate1" className="l mt-0">
                          {p.rate}%
                        </p>
                      </div>
                      <div className="column3">
                        <label htmlFor="fixedrate1">Yearly saving</label>
                        <p id="fixedrate1" className="l mt-0">
                          <NumberAsCurrency value={p.yearlySavings} />
                        </p>
                      </div>
                      <div
                        className="column3"
                        style={{ marginTop: "auto", marginBottom: "auto" }}
                      >
                        <GetStartedButton onClick={() => this.nextStep()} />
                      </div>
                    </div>
                  </div>
                );
              }
            )}
        </div>
      </header>
    );
  }
}
